import React, { useEffect, useRef, useState } from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/gl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { useKeycloak } from "@react-keycloak/web";
import ShareIcon from "@material-ui/icons/Share";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import {
  URL_HOME,
  URL_PLAYER,
  URL_LOGIN,
} from "../../../../app/src/Components/Routes/Location";
import AlertNotification from "../../../../app/src/Components/GUI/Alert/Alert";
import Comments from "./Comments";
import Casting from "./Casting";
import Playlist from "./Playlist";
import Favorite from "./Favorite";
import Rating from "./Rating";
import VideoTag from "./VideoTag";
import VideoType from "./VideoType";
import "./VideoDetailPage.css";
import "./ReportContent.css";
import backgroundDegraded from "../../../../app/src/Resources/Images/degradado600.png";
import {
  DETAIL_TYPE_CONTAINER,
  REDIRECT_TO_HOME,
  REDIRECT_TO_LOGIN,
  LOAD_NEXT_CONTENT,
  LOAD_CONTENT_PLAYER,
  REDIRECT_TO_PRODUCTS,
  SHOW_AGE_RESTRICTION_MODAL,
  SHOW_QR_MODAL,
  REDIRECT_TO_STRIPE,
} from "./VideoDetailPageConstants";
import {
  saveContentActionCreator,
  saveContentHashActionCreator,
  saveContentPermissionsActionCreator,
  saveContentTypeActionCreator, saveProductsActionCreator,
  saveUserDataActionCreator,
  turnOffLoadingActionCreator,
  turnOnLoadingActionCreator,
} from "../../../../app/src/actions/commonActions";
import ReportContentModalComponent from "./ReportContentModalComponent";
import ShareContentModalComponent from "./ShareContentModalComponent";
import ExpiredSessionModalComponent from "../../../../app/src/Components/common/ExpiredSessionModalComponent";
import {
  URL_PRODUCTS,
  URL_VIDEODETAIL,
} from "../../../../app/src/Components/Routes/Location";
import {
  LOCAL_STORAGE_KEY__LOCALE,
  VIDEO_TYPE_LIVE,
  VIDEO_TYPE_LIVE_TIIVII,
  VIDEO_TYPE_TIIVII_LIVE,
  VIDEO_TYPE_EXTERNAL_LIVE,
  VIDEO_TYPE_EXTERNAL_IFRAME,
  WIDGET_ACTION_DETAIL, WIDGET_TYPE_BANNER,
  AGE_RESTRICTION_18_PLUS,
  AGE_RESTRICTION_16_PLUS,
  AGE_RESTRICTION_12_PLUS,
  AGE_RESTRICTION_7_PLUS
} from "../../../../app/src/Utils/Constants";
// import QRModalComponent from "../../../../app/src/Components/common/QRModalComponent";
import ErrorMessageModalComponent from "../../../../app/src/Components/common/ErrorMessageModalComponent";
import AgeRestrictionModalComponent from "../../../../app/src/Components/common/AgeRestrictionModalComponent";
import {
  TENANT,
  TENANT_PETISGO,
  MULTITENANT_CONSTANTS,
} from "../../../../app/src/Resources/Multitenant/tenantConstants";
import CalendarButtonComponent from "./CalendarButtonComponent";
import {
  getProductsDashboardService,
  getUserDataService,
  logUserAnalyticService,
  getAnonContentsService,
  getRelatedContentsService,
  getSerialContentsService,
  getContentPermissions,
  getContentsService,
  getUserFavorites,
  getCommentsService,
  reportContentService,
} from "../../../../app/src/services/services";
import {
  DETAIL_VALUE,
  PAGE_ID_KEY,
  PAGE_VIEW_ACTION,
  SELECT_ITEM_ACTION,
} from "../../../../app/src/analyticsConstants/analyticsConstants";
import WithAuthorization from "../../../../app/src/Utils/WithAuthorization";
import {
  DEFAULT_COMMENT_LIMIT,
  DEFAULT_COMMENT_SORT,
  DEFAULT_PAGE,
} from "./CommentsConstants";
import i18n from "../../../../app/src/i18n";
import {URL_BASE_IMAGE} from "../../../../app/src/services/servicesConstants";
import {getToken, getWidgetDescription, getWidgetTitle, getAgeRestrictionLabel} from "../../../../app/src/Utils/utils";
import { usePageSeo } from "../../../../app/src/Utils/usePageSeo";
import {USER_ANONYMOUS} from "../../../../home/src/Pages/Home/HomeComponentConstants";
import { isCordovaAvailable } from "../../../../app/src/Utils/secureStorageUtil";

const VideoDetailPage = ({ scrollRef }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  let { id } = useParams();
  const isMobile = isCordovaAvailable();
  const isMobileWidth = window.innerWidth < 480;
  const { keycloak, initialized } = useKeycloak();
  const userToken = getToken(keycloak);
  const { userData: userDetails, userLogin } = useSelector((state) => state.commonState);
  const username = keycloak?.tokenParsed?.preferred_username || userDetails?.username || userLogin;

  const userInformation = useSelector((state) => state.commonState.userData);
  const translations = useSelector((state) => state.commonState.translations);
  const { userURLAvatar } = useSelector((state) => state.commonState);
  const query = new URLSearchParams(window.location.search);
  const payload = query.get("payload") || false;

  const titleColor = document
    .getElementById("root")
    .style.getPropertyValue("--rowTitleColor");

  const [content, setContent] = useState(null);
  const [serialContents, setSerialContens] = useState([]);
  const [totalComments, setTotalComments] = useState(null);
  const [userAvatar, setUserAvatar] = useState(null);
  const [userData, setUserData] = useState(null);
  const [displayOptions, setDisplayOptions] = useState(null);
  const [sentMessage, setSentMessage] = useState(false);
  const [reason, setReason] = useState(null);
  const [reasonDescription, setReasonDescription] = useState(undefined);
  const [reportSuccess, setReportSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [shareContent, setShareContent] = useState(null);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);
  const [displayQRModal, setDisplayQRModal] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [calendarButton, setCalendarButton] = useState(null);
  const [accessBehavior, setAccessBehavior] = useState(null);
  const [urlToRedirect, setUrlToRedirect] = useState(null);
  const [checkoutURL, setCheckoutURL] = useState(null);
  const [allowed, setAllowed] = useState(undefined);
  const [widgetType, setWidgetType] = useState(WIDGET_TYPE_BANNER);
  const [serialWidgetType, setSerialWidgetType] = useState(WIDGET_TYPE_BANNER);
  const [isPayRequired, setIsPayRequired] = useState(false);
  const [isAgeRestricted, setIsAgeRestricted] = useState(false);
  const [hasAgeRestriction, setHasAgeRestriction] = useState(false);
  const [ageRestrictionTag, setAgeRestrictionTag] = useState(null);
  const [allComments, setAllComments] = useState(null);
  const [textMessageErrorBody, setTextMessageErrorBody] = useState(
    "error.modal.rating.message"
  );
   const isLoginRequired = MULTITENANT_CONSTANTS[TENANT].showLoginButton;

  const refOptions = useRef(null);
  const refShare = useRef(null);

  const tenantStyles = useSelector((state) => state.commonState.tenantStyles);

  const seoTitle = getWidgetTitle(content?.content);
  const seoDescription = getWidgetDescription(content?.content) || tenantStyles?.description;

  usePageSeo({
    title: seoTitle,
    description: seoDescription,
    tenantStyles,
  });

  const version = MULTITENANT_CONSTANTS[TENANT].contentDetailsVersion
    ? MULTITENANT_CONSTANTS[TENANT].contentDetailsVersion
    : 1;

  const languageSelected =
    useSelector((state) => state.commonState.languageSelected) || i18n.language;

  const locale = localStorage.getItem(LOCAL_STORAGE_KEY__LOCALE) || i18n.language;

  const loadTenantLocale = () => {
    moment.locale(tenantStyles.momentLocale);
  };

  const getCommentsCallback = (response) => {
    if (!response || !response.comments) {
      setAllComments([]);
      return;
    }
    const sortedComments = response.comments.sort((a, b) => new Date(b.date) - new Date(a.date));
    setAllComments(sortedComments);
  };

  useEffect(() => {
  }, [allComments]);

  useEffect(() => {
    if (!!userURLAvatar) {
      setUserAvatar(userURLAvatar);
    }
  }, [userURLAvatar]);

  useEffect(() => {
    isLoginRequired && MULTITENANT_CONSTANTS[TENANT].showComments &&
    getCommentsService(
      TENANT,
      id,
      DEFAULT_COMMENT_LIMIT,
      DEFAULT_PAGE,
      DEFAULT_COMMENT_SORT,
        userToken,
      getCommentsCallback
    );
    loadTenantLocale();
  }, [id]);

  useEffect(() => {
    !!username && MULTITENANT_CONSTANTS[TENANT].analytics && logUserAnalyticService(
      TENANT,
      username,
      PAGE_VIEW_ACTION,
      PAGE_ID_KEY,
      DETAIL_VALUE,
      userToken
    );
  }, [userData]);

  const handleShareContent = () => {
    setShareContent(!shareContent);
  };

  const hideShareModal = () => {
    setShareContent(false);
  };

  const toggleOptions = () => {
    setDisplayOptions(!displayOptions);
  };

  const reportContentServiceCallback = () => {
    setReportSuccess(true);
    setSentMessage(true);
  };

  useEffect(() => {
    if (reportSuccess === true) {
      setTimeout(() => {
        setReportSuccess(false);
      }, 3000);
    }
  }, [reportSuccess]);

  const handleReportContent = () => {
    reportContentService(TENANT, id, reasonDescription, userToken, reportContentServiceCallback);
    setReason(null);
  };

  const handleCloseModal = () => {
    setReasonDescription(undefined);
    setSentMessage(false);
    setDisplayOptions(false);
  };

  const handleSetReason = (value) => {
    setReason(value);
  };

  const handleSetReasonDescription = (event) => {
    setReasonDescription(event.target.value);
    handleSetReason(!!event.target.value);
  };

  const hideOptions = () => {
    setReason(null);
    setDisplayOptions(false);
  };

  const turnOnLoading = () => {
    dispatch(turnOnLoadingActionCreator());
  };

  const turnOffLoading = () => {
    dispatch(turnOffLoadingActionCreator());
  };

  const getRelatedServiceCallback = (response) => {
    setContent((prev) => ({ ...prev, relatedContent: response["contents-related"]?.data, serialContent: response["contents-items"]?.data }));
    setWidgetType(response["contents-related"]?.widget_type ?? WIDGET_TYPE_BANNER);
    setSerialWidgetType(response["contents-items"]?.widget_type ?? WIDGET_TYPE_BANNER);
  };

  const sortContents = (contents) => {
    const orderedContents = contents.sort((a, b) =>
      a.episode > b.episode ? 1 : b.episode > a.episode ? -1 : 0
    );

    return orderedContents;
  };

  useEffect(() => {
    if (content?.content?.type !== "container" && serialContents?.length > 0) {
      const nextContentId = parseInt(id, 10) + 1;
      const contentFiltered = serialContents.find(
        (item) => item.id === nextContentId
      );
      if (contentFiltered) {
        setContent((prev) => ({ ...prev, nextContent: contentFiltered }));
      }
    }
  }, [serialContents, id, content?.content?.type]);

  const getSerialContentsCallback = (response, allowed) => {
    if (response.data[0].type !== "container") {
      setSerialContens(response.data);
      setAccessBehavior(
        allowed
          ? LOAD_NEXT_CONTENT
          : REDIRECT_TO_LOGIN
      );
    } else {
      setAccessBehavior(null);
    }
    const serialContents = sortContents(response.data);
  //  setContent((prev) => ({ ...prev, serialContent: serialContents }));
  };

  const getWatchNextCallback = (response) => {
    const orderedContents = sortContents(response.data);
    setSerialContens([...orderedContents]);
  };

  useEffect(() => {
    if (
      serialContents?.length === 0 &&
      content?.content?.parent?.type === "container"
    ) {
      getSerialContentsService(
        TENANT,
        content?.content?.parent.id,
          undefined,
        getWatchNextCallback
      );
    }
  }, [serialContents, content]);

  const contentPermissionsCallback = (response, contentType, id) => {
    dispatch(saveContentPermissionsActionCreator({response, contentType, id}));
    const allowedResponse = response?.allowed;
    if (allowedResponse !== undefined) {
        setAllowed(allowedResponse);
      if (contentType === "container") {
        getSerialContentsService(TENANT, id, allowedResponse, getSerialContentsCallback);
      } else {
        if(response?.hashRequired) dispatch(saveContentHashActionCreator(response.hash));
        allowedResponse ? setAccessBehavior(LOAD_CONTENT_PLAYER) : setAccessBehavior(REDIRECT_TO_PRODUCTS);
      }
    } else {
      setAccessBehavior(redirectUserTo(response));
    }
    turnOffLoading();
  };

  const getUserFavoritesCallback = (response) => {
    const favoriteContents = response.data;
    let isFavorite = false;

    favoriteContents?.forEach((item) => {
      if (item.id === parseInt(id, 10)) {
        isFavorite = true;
      }
    });

    setContent((prev) => ({ ...prev, isFavorite: isFavorite }));
  };

  const  scrollMoving = () => {
    if (scrollRef?.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }

  const getContentsCallback = (response, id) => {
    const responseContent = response.data;
    const contentType = responseContent.type;
    dispatch(saveContentTypeActionCreator(contentType));
    dispatch(saveContentActionCreator({...responseContent, id}));
    setHasAgeRestriction(false);
    setAgeRestrictionTag(getAgeRestrictionLabel(responseContent?.rating?.code));
    setContent({
      content: responseContent,
      isFree: false,
      canRate: true,
      canFav: true,
      canReport: true,
    });
    if (!!id && isLoginRequired) {
      getContentPermissions(
          TENANT,
          id,
          userToken,
          contentType,
          (response, type) => {contentPermissionsCallback(response, type, id)}
      );
    }
    getRelatedContentsService(TENANT, id, locale, getRelatedServiceCallback);
    getUserFavorites(TENANT, username, userToken, getUserFavoritesCallback);
    scrollMoving();
  };

  const getAnonContentsCallback = (response, id) => {
    const responseContent = response?.data;
    const contentType = responseContent?.type;
    dispatch(saveContentTypeActionCreator(contentType));
    dispatch(saveContentActionCreator({...responseContent, id}));
    setAgeRestrictionTag(getAgeRestrictionLabel(responseContent?.rating?.code));
    setHasAgeRestriction(false);
    setContent({
      content: responseContent,
      isFree: false,
      canRate: false,
      canFav: false,
    });
    if(!!id) {
      getContentPermissions(
          TENANT,
          id,
          undefined,
          contentType,
          (response, type) => {contentPermissionsCallback(response, type, id)}
      );
    }
    getRelatedContentsService(
      TENANT,
      id,
      locale,
      getRelatedServiceCallback
    );
    scrollMoving();
  };

  const redirectUserTo = (response) => {
    let actionToRedirect = REDIRECT_TO_LOGIN;
    const errorBody = JSON.parse(response.error_error.http_body);
      switch (response.error_error.http_status_code) {
        case 401:
          setUrlToRedirect(URL_LOGIN);
          break;
        case 403:
          const errorKey = errorBody.error?.key;
          
          if (errorKey === "age-restriction") {
            setIsAgeRestricted(true);
            setHasAgeRestriction(true);
            setIsPayRequired(false);
            setTextMessageErrorBody("error.modal.age.restriction.message");
            actionToRedirect = SHOW_AGE_RESTRICTION_MODAL;
          } else {
            setIsPayRequired(true);
            setIsAgeRestricted(false);
            setTextMessageErrorBody("");
            dispatch(saveProductsActionCreator(errorBody.error.products));
            setUrlToRedirect(URL_PRODUCTS + "/" + id);
            actionToRedirect = REDIRECT_TO_PRODUCTS;
          }
          break;
        default:
          console.error('Error no manejado:', response.error_error.http_status_code);
      }
      return actionToRedirect;
  }

  const anonContentPermissionsCallback = (response, contentType, id) => {
    dispatch(saveContentPermissionsActionCreator({response, contentType, id}));
    const allowed = !!response.allowed;
    if (contentType === "container") {
      getSerialContentsService(TENANT, id, allowed, getSerialContentsCallback);
    } else {
          dispatch(saveContentHashActionCreator(response.hash));
          setAccessBehavior(!allowed ? REDIRECT_TO_LOGIN
              : LOAD_CONTENT_PLAYER
          );
      }
    turnOffLoading();
  };

  useEffect(() => {
    if (!!username) {
      getContentsService(TENANT, id, userToken, payload, (response) => {getContentsCallback(response, id)});
    } else {
      getAnonContentsService(TENANT, id, payload, (response) => {getAnonContentsCallback(response, id)});
    }
  }, [id, languageSelected, username]);


  const productCheckoutCallback = (data) => {
    setCheckoutURL(data.url);
  };

  useEffect(() => {
    if ((!!keycloak.authenticated && !!initialized) || isCordovaAvailable()) {
        const body = { returnUrl: `${window.location.origin}/user` };
        getProductsDashboardService(
          MULTITENANT_CONSTANTS[TENANT].tenantServer,
          username,
          locale,
          userToken,
          body,
          productCheckoutCallback
        );
      }
  }, []);

  const getReportTypesCallback = (response) => {
    const reportTypes = response.data;
    const updatedContent = { ...content, availableReportReasons: reportTypes };
    setContent(updatedContent);
  };

  useEffect(() => {
    //getReportTypesService(TENANT, getReportTypesCallback);
  }, []);

  const getUserDataCallback = (response) => {
    dispatch(saveUserDataActionCreator(response));
    setUserData(response);
  };

  useEffect(() => {
    if (isLoginRequired && !!userInformation?.username) {
      setUserData(userInformation);
    } else if (isLoginRequired && !!username) {
      getUserDataService(
        MULTITENANT_CONSTANTS[TENANT].tenantServer,
        username,
        keycloak.token,
        getUserDataCallback
      );
    }
  }, [userInformation]);

  if (!id) {
    return <Redirect to={URL_HOME} />;
  }

  const selectedVideo = (id) => {
    const username = userData?.username ? userData?.username : USER_ANONYMOUS;
    !!username && MULTITENANT_CONSTANTS[TENANT].analytics && logUserAnalyticService(
      TENANT,
      username,
      SELECT_ITEM_ACTION,
      PAGE_ID_KEY,
      DETAIL_VALUE,
      userToken,
      id
    );
  };

  const handleCloseSessionModal = () => {
    setSessionExpiredModal(false);
  };

  const handleGoToPlayer = (array) => {
    const filteredArray = array.filter(
      (item) => item.type !== DETAIL_TYPE_CONTAINER
    );
    history.push(URL_PLAYER + "/" + filteredArray[0].id);
  };

  const handleQRModal = () => {
    setDisplayQRModal((displayQRModal) => !displayQRModal);
  };

  const handleGoToLogin = () => {
    if (isCordovaAvailable()) {
      history.push(URL_LOGIN);
    } else {
      const currentUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      localStorage.setItem("redirectAfterLogin", currentUrl);
      setMessageModal(true);
      setTextMessageErrorBody("error.modal.rating.message");
      setUrlToRedirect(URL_LOGIN);
    }
  };

  const handleGoToHome = () => {
    setUrlToRedirect(URL_HOME);
    setMessageModal(true);
    setTextMessageErrorBody("error.modal.common.title");
  };

  const handleGoToSeeContent = () => {
    history.push(URL_PLAYER + "/" + content?.content?.id);
  };

  const handleAgeRestrictionModal = () => {
    setIsAgeRestricted(true);
    setMessageModal(true);
  };

  const handleGoToSeeNextContent = () => {
    turnOnLoading();
    history.push(URL_VIDEODETAIL + "/" + content?.nextContent?.id);
  };

  const handleGoToProducts = () => {
    history.push(URL_PRODUCTS + "/" + id);
      }

  const handleGoToOpenModal = () => {
    setMessageModal(true);
  }
  const getTranslation = (field) => {
    const translation = translations.find(t => t.language === languageSelected);
    return translation ? translation[field] : t(field);
  };

  const groupButtonsContent = () => {
    if (!MULTITENANT_CONSTANTS[TENANT].showViewButton) {
      if (content?.content?.type === DETAIL_TYPE_CONTAINER.toLowerCase()) {
        return null;
      }
    }
    
    return accessBehavior === LOAD_CONTENT_PLAYER ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleGoToSeeContent}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.vercontido")}
        </button>
      </div>
    ) : isLoginRequired && accessBehavior === REDIRECT_TO_LOGIN ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleGoToLogin}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.vercontido")}
        </button>
      </div>
    ) : accessBehavior === REDIRECT_TO_HOME ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleGoToHome}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.vercontido")}
        </button>
      </div>
    ) : accessBehavior === REDIRECT_TO_PRODUCTS ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleGoToOpenModal}
        >
          <SubscriptionsIcon />
          {getTranslation("ppv_botton")}
        </button>
      </div>
    ) : accessBehavior === SHOW_AGE_RESTRICTION_MODAL ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleAgeRestrictionModal}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.vercontido")}
        </button>
      </div>
    ) : accessBehavior === LOAD_NEXT_CONTENT &&
      content?.serialContent?.length > 0 ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={() => handleGoToPlayer(content.serialContent)}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.comezarver")}
        </button>
      </div>
    ) : accessBehavior === SHOW_QR_MODAL ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleQRModal}
        >
          <PlayCircleOutlineIcon />
          {t("ficha.comezarver")}
        </button>
      </div>
    ) : accessBehavior === REDIRECT_TO_STRIPE ? (
      <div className="boton-play">
        <button
          className={`BotonVer ${version === 2 && "BotonVerV2"} ${
            !checkoutURL && "buttonDisabled "
          }`}
          disabled={!checkoutURL}
          onClick={!!checkoutURL && (() => window.open(checkoutURL))}
        >
          {t("products.subscribe")}
        </button>
      </div>
    ) : (
      <></>
    );
  };

  const extraContent = (content) => {
    return (
      <>
        {(content?.isFree || !content?.isFree) && (
          <div className={"textBlock"}>
            <div className={"textTitle alignLeft"}>
              {t("ficha.tipocontenido")}
            </div>
            {content?.isFree ? (
              <div className={"textInfo"}>
                {t("ficha.opciondecontenidogratis")}
              </div>
            ) : (
              <div className={"textInfo"}>
                {t("ficha.opciondecontenidopago")}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  const renderCalendarButton = () => {
    const contentTypeCondition =
      content?.content?.type === VIDEO_TYPE_LIVE ||
      content?.content?.type === VIDEO_TYPE_LIVE_TIIVII ||
      content?.content?.type.toLowerCase() === VIDEO_TYPE_TIIVII_LIVE.toLowerCase();
    const contentDate = new Date(content?.content?.starttime || content?.content?.start * 1000);
    const now = new Date();

    const dateCondition = contentDate > now;
    setCalendarButton(!!MULTITENANT_CONSTANTS[TENANT]?.showCalendarButton && !!contentTypeCondition && !!dateCondition);
  };

  useEffect(() => {
    if (!!content) {
      renderCalendarButton();
    }
  }, [content]);

  const AGE_BADGE_CLASSES = {
    [AGE_RESTRICTION_7_PLUS]: "ageBadge--7",
    [AGE_RESTRICTION_12_PLUS]: "ageBadge--12",
    [AGE_RESTRICTION_16_PLUS]: "ageBadge--16",
    [AGE_RESTRICTION_18_PLUS]: "ageBadge--18",
  };

  const detailTitleAndAuthor = () => {
    const badgeCode = hasAgeRestriction ? AGE_RESTRICTION_18_PLUS : ageRestrictionTag;
    const ageBadgeLabel = badgeCode;
    const ageBadgeClass = AGE_BADGE_CLASSES[badgeCode];

    return (
        <div className={`FichaTitle ${version === 2 && "FichaTitleV2"}`}>
          <div className="TitleContainer">
            {getWidgetTitle(content?.content)}
            {ageBadgeLabel && (
              <span className={`AgeBadgeTitle ${ageBadgeClass || ""}`}>
                {ageBadgeLabel}
              </span>
            )}
          </div>
          {MULTITENANT_CONSTANTS[TENANT].showAuthor && (
              <span
                  className={"ContentAuthor"}> {t('reportcontent.author')} {content?.content?.author}
            </span>)}
        </div>
    );
  };

  const detailEmisionDateTime = () => {
    const isLiveContent =
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_EXTERNAL_LIVE.toLowerCase() ||
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_TIIVII_LIVE.toLowerCase() ||
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_EXTERNAL_IFRAME.toLowerCase();

    if (!isLiveContent) {
      return null;
    }

    const startTimestamp =  content?.content?.start;
    const finishTimestamp = content?.content?.finish;

    if (!startTimestamp || !finishTimestamp) {
      return null;
    }

    const startDate = typeof startTimestamp === 'number' 
      ? new Date(startTimestamp * 1000) 
      : new Date(startTimestamp);

    const formattedDateTime = moment(startDate).format("LLLL");

    return (
      <div className="EmisionDateTime">
        <span className="EmisionDateTimeLabel">{t("ficha.emisionDateTime")}: </span>
        <span className="EmisionDateTimeValue">{formattedDateTime}</span>
      </div>
    );
  };

  const detailCategory = () => {
    return (
      content?.content?.category &&
      MULTITENANT_CONSTANTS[TENANT].showCategory && (
        <span className="Xenero">{content?.content?.category?.code}</span>
      )
    );
  };

  const detailPublishDate = () => {
    return (
      content?.content?.publishDate &&
      MULTITENANT_CONSTANTS[TENANT].showPublishDate && (
        <span className="Data">
          {moment(content?.content.publishDate, "YYYY-MM-DD").format("ll")}
        </span>
      )
    );
  };

  const detailSeasons = () => {
    return (
        content?.content?.seasons && (
        <span className="Temporadas">
          {t("ficha.seasons", { seasons: content?.content.seasons })}
        </span>
      )
    );
  };

  const detailRating = () => {
    return (
      content?.content?.rating &&
      MULTITENANT_CONSTANTS[TENANT].showRating && (
        <span className="Idade">
          {t("ficha.rating", { rating: content?.content?.rating?.code })}
        </span>
      )
    );
  };

  const detailBackToSeason = () => {
    return (
      !!content?.content?.parent &&
      MULTITENANT_CONSTANTS[TENANT].showBackToSeason && (
        <span className="button-back">
          <Link
            to={URL_VIDEODETAIL + "/" + content?.content?.parent?.id}
            className=""
          >
           {MULTITENANT_CONSTANTS[TENANT].seasonClassification ?
               t('ficha.backToSeason')  :
               t('ficha.back')
           }
          </Link>
        </span>
      )
    );
  };

  const detailWatchNext = () => {
    return (
      accessBehavior === LOAD_CONTENT_PLAYER &&
      !!content?.content?.parent?.id &&
      content?.nextContent?.parent.id === content?.content?.parent?.id && (
          <div className="boton-play">
          <button
          className={`BotonVer ${version === 2 && "BotonVerV2"}`}
          onClick={handleGoToSeeNextContent}
        >
          {t("ficha.watchNext")}
        </button>
          </div>
      )
    );
  };

  const setFavoriteCallback = (isFavorite) => {
    setContent((prev) => ({ ...prev, isFavorite: isFavorite }));
  }

  const detailFavorite = () => {
    return (
      content?.canFav &&
      content.content.type !== "container" && (
        <Favorite
          isFavorite={content?.isFavorite}
          id={id}
          username={username}
          largeVersion={version === 2}
          version={isMobileWidth ? 1 : version}
          token={userToken}
          setFavorite={setFavoriteCallback}
        />
      )
    );
  };

  const detailShare = () => {
    return (
      <div className="Share" onClick={() => handleShareContent()}>
        <ShareIcon />
      </div>
    );
  };

  const detailCalendar = () => {
    return calendarButton && <CalendarButtonComponent detail={content} />;
  };

  const detailTags = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showVideoTags &&
      content?.content?.tags?.length > 0 && (
        <div
          className={`VotesCategoriesContainer ${
            version === 2 && "VotesCategoriesContainerV2 CategoriesV2"
          }`}
        >
          <VideoType subtitle={content?.content} />
          {content?.content?.tags?.map((t, index) => (
            <VideoTag tag={t} key={t + "-" + index} />
          ))}
        </div>
      )
    );
  };

  const detailScore = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showScore && (
        <div
          className={`VotesCategoriesContainer ${
            version === 2 && "VotesCategoriesContainerV2"
          }`}
        >
          <Rating
            videoDetailId={content?.content.id}
            username={userData?.username}
            editRating={content?.canRate}
            totalRating={content?.content?.valoration}
            votes={content?.content?.votes}
            id={id}
          />
        </div>
      )
    );
  };

  const detailDescriptionMisc = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showVideoDetails && (
        <div
          className={`textDetailContainer ${
            version === 2 && "textDetailContainerV2"
          }`}
        >
          {MULTITENANT_CONSTANTS[TENANT].showAuthor &&
            content?.content?.author !== null && (
              <div className={"textBlock"}>
                <div className={"textTitle alignLeft"}>{t("ficha.autor")}</div>
                <div className={"textInfo"}>{content?.content?.author}</div>
              </div>
            )}
          {content?.content?.category !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>
                {t("ficha.categoria")}
              </div>
              <div className={"textInfo"}>
                {content?.content?.category?.code}
              </div>
            </div>
          )}
          {content?.content?.subcategory !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>
                {t("ficha.subcategoria")}
              </div>
              <div className={"textInfo"}>
                {content?.content?.subcategory?.code}
              </div>
            </div>
          )}
          {content?.content?.publishDate !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>{t("ficha.estreno")}</div>
              <div className={"textInfo"}>
                {moment(content?.content?.publishDate).format("DD-MM-YYYY")}
              </div>
            </div>
          )}
          {TENANT !== TENANT_PETISGO && extraContent(content)}
        </div>
      )
    );
  };

  const detailReport = () => {
    return (
      content?.canReport &&
      MULTITENANT_CONSTANTS[TENANT].showReportContentOption &&
      content?.content?.type !== "container" && (
        <div
          className={`"ReportContentContainer" ${
            version === 2 && "ReportContentContainerV2"
          }`}
        >
          <div className="ReportContent">
            <div
              className="ReportContentButton"
              onClick={() => toggleOptions()}
            >
              <span className="ReportIcon">
                {t("reportcontent.reportbuttonicon")}
              </span>
              <span className="ReportText">
                {t("reportcontent.reportbutton")}
              </span>
            </div>
          </div>
        </div>
      )
    );
  };

  const detailPlayFav = () => {
    return (
      <div
        className={`PlayFavContainer ${version === 2 && "PlayFavContainerV2"}`}
      >
        {groupButtonsContent()}
        {detailWatchNext()}
        {!!username && detailFavorite()}
        {(version !== 2 || (!!MULTITENANT_CONSTANTS[TENANT]?.showShareButtons && isMobile)) && detailShare()}
        {detailCalendar()}
      </div>
    );
  };

  const detailDescriptionTitle = () => {
    return (
      <p
        className={`DescriptionTitle ${version === 2 && "DescriptionTitleV2"}`}
      >
        {t("detail.description")}
      </p>
    );
  };

  const detailDescriptionDetail = () => {
    return (
      <div
        className={`DescriptionDetail ${
          version === 2 && "DescriptionDetailV2"
        }`}
      >
        {getWidgetDescription(content.content)}
      </div>
    );
  };

  const detailViewV2 = () => {
    return (
      <>
        <div className={"contentPrincipalImage"}></div>
        <div className="FichaOverContainer FichaOverContainerV2">
          <div className="detailsContainer">
            <div className="leftSide">
              {detailTitleAndAuthor()}
              {detailEmisionDateTime()}
              <div className="InfoPrevia InfoPreviaV2">
                {detailCategory()}
                {detailPublishDate()}
                {MULTITENANT_CONSTANTS[TENANT].playMarathon || (!MULTITENANT_CONSTANTS[TENANT].playMarathon && !!content?.content?.parentId) && detailSeasons()}
                {detailRating()}
                {detailBackToSeason()}
              </div>
              {detailPlayFav()}
            </div>
            <div className="rightSide">
              {detailScore()}
              {detailTags()}
              {detailReport()}
            </div>
          </div>
        </div>
      </>
    );
  };

  const detailViewV1 = () => {
    return (
      <div className={"contentPrincipalImage"}>
        <div
          className="FichaOverContainer"
          style={{ backgroundImage: "url(" + backgroundDegraded + ")" }}
        >
          {detailTitleAndAuthor()}
          {detailEmisionDateTime()}
          {detailScore()}
          {detailTags()}
          {detailPlayFav()}
          <div className={`InfoPrevia InfoPreviaV2`}>
            {detailCategory()}
            {detailPublishDate()}
            {MULTITENANT_CONSTANTS[TENANT].playMarathon || (!MULTITENANT_CONSTANTS[TENANT].playMarathon && !!content?.content?.parentId) && detailSeasons()}
            {detailRating()}
            {detailBackToSeason()}
          </div>
          {detailReport()}
        </div>
      </div>
    );
  };

  const descriptionViewV2 = () => {
    return (
      <Col>
        <Row>{detailDescriptionTitle()}</Row>
        <Row>{detailDescriptionDetail()}</Row>
        <Row>{detailDescriptionMisc()}</Row>
      </Col>
    );
  };

  const descriptionViewV1 = () => {
    return (
      <Row>
        <Col md={12} lg={6}>
          {detailDescriptionTitle()}
          {detailDescriptionDetail()}
        </Col>
        <Col md={12} lg={5}>
          {detailDescriptionMisc()}
        </Col>
      </Row>
    );
  };

  const ppvModalText = getTranslation("ppv_modal_text") || "";

  return (
    <div className="VideoDetailPage" id="detailContainer">
      {error && <AlertNotification />}
      {reportSuccess && (
        <AlertNotification
          type="success"
          showtitle={false}
          text={t("reportcontent.success")}
        />
      )}
      {content !== null && content?.content && (
        <>

<div className={"principalImage"}>
  {!!content?.content?.background?.data?.asset_url && (
    <img
      src={`${URL_BASE_IMAGE}${content?.content?.background?.data?.asset_url}`}
      alt={"Cover image"}
                style={{
                  pointerEvents: accessBehavior === REDIRECT_TO_LOGIN ||
                    (content?.content?.type !== "container" || content?.serialContent?.length > 0)
                    ? "auto"
                    : "none",

                  cursor: accessBehavior === REDIRECT_TO_LOGIN ||
                    (content?.content?.type !== "container" || content?.serialContent?.length > 0)
                    ? "pointer"
                    : "default",
                }}
      onClick={() => {
        if (accessBehavior === REDIRECT_TO_LOGIN) {
          handleGoToLogin();
                    return;
                  }
                  if (content?.serialContent?.length > 0) {
                    handleGoToPlayer(content.serialContent);
                  } else if (content?.content?.type !== "container") {
                    handleGoToSeeContent();
        }
      }}
    />
  )}
  {version === 2 ? detailViewV2() : detailViewV1()}
</div>
          {content?.serialContent && (
            <div className={"playlistContainer serialContent"}>
              <Playlist
                clickCallback={selectedVideo}
                playlist={content?.serialContent}
                typeBanner={serialWidgetType}
                detail={true}
                trigger={WIDGET_ACTION_DETAIL}
                className="FrameworkHome"
                turnOffLoading={turnOffLoading}
                turnOnLoading={turnOnLoading}
                titleColor={titleColor}
                contentId={content?.content.id}
              />
            </div>
          )}
          <div className={"contentContainer"}>
            {version === 2 ? descriptionViewV2() : descriptionViewV1()}
            {content?.content?.participants.length > 0 && (
              <Casting
                className="FichaCasting"
                participants={content?.content?.participants}
              />
            )}
            {isLoginRequired && MULTITENANT_CONSTANTS[TENANT].showComments &&
             allComments !== null && (
            <div className="CommentsContainer">
                  <Comments
                    comments={allComments}
                    videoDetailId={content?.content.id}
                    userName={username}
                    totalComments={totalComments}
                    titulo={t("ficha.doacomment")}
                    placeholder={t("ficha.commentplaceholder")}
                    avatar={userAvatar}
                    token={userToken}
                  />
            </div>
                )}
          </div>

          <div className="FichaInfoRelated">
            {content?.relatedContent && (
              <Playlist
                title={t("ficha.explora")}
                clickCallback={selectedVideo}
                hideSubtitle={true}
                playlist={content?.relatedContent}
                typeBanner={widgetType}
                detail={true}
                className="FrameworkHome"
                turnOffLoading={turnOffLoading}
                turnOnLoading={turnOnLoading}
                trigger={WIDGET_ACTION_DETAIL}
                titleColor={titleColor}
                contentId={content?.content.id}
              />
            )}
          </div>
          {displayOptions && (
            <ReportContentModalComponent
              refOptions={refOptions}
              availableReportReasons={content?.availableReportReasons}
              hideOptions={hideOptions}
              reason={reason}
              handleSetReason={handleSetReason}
              reasonDescription={reasonDescription}
              handleSetReasonDescription={handleSetReasonDescription}
              handleReportContent={handleReportContent}
              handleCloseModal={handleCloseModal}
              sentMessage={sentMessage}
            />
          )}
          {shareContent && (
            <ShareContentModalComponent
              hideShareModal={hideShareModal}
              refShare={refShare}
              title={content?.content?.title}
              description={content?.content?.description}
            />
          )}
        </>
      )}
      {isLoginRequired && !isPayRequired && !isAgeRestricted && messageModal && (
        <ErrorMessageModalComponent
          textTitle="error.modal.common.title"
          textBody={textMessageErrorBody}
          textButton="user.login"
          url={urlToRedirect}
          onClose={() => { setMessageModal(false); }}
        />
      )}
      {isLoginRequired && isPayRequired && !isAgeRestricted && messageModal && (
          <ErrorMessageModalComponent
              textTitle={ppvModalText} // Aquí se usa el texto plano en vez del HTML
              textBody={textMessageErrorBody}
              textButton="user.payment"
              url={urlToRedirect}
              onClose={() => { setMessageModal(false); }}
          />
      )}
      {isLoginRequired && isAgeRestricted && messageModal && (
          <AgeRestrictionModalComponent
              onClose={() => { setMessageModal(false); setIsAgeRestricted(false); }}
          />
      )}
      {isLoginRequired && sessionExpiredModal && (
        <ExpiredSessionModalComponent
          handleCloseModal={handleCloseSessionModal}
        />
      )}
      {/* Quizas se use en un futuro */}
      {/*displayQRModal && (
        <QRModalComponent
          url={''}
          goBack={false}
          handleCloseQRModal={handleQRModal}
        />
      )*/}
    </div>
  );
};

export default WithAuthorization(VideoDetailPage);
